import { Box, Button, Container, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { motion } from "framer-motion";
import heroImg from "../../static/Home/Hero.webp";

function HeroSection() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box sx={{ width: "100%" }}>
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: { xs: 2, md: 4 }
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            borderRadius: "18px",
            overflow: "hidden"
          }}
        >
          <Box
            component="img"
            src={heroImg}
            alt="Tournament Hero"
            sx={{
              width: "90%",
              height: "auto",
              borderRadius: "18px",
              display: "block"
            }}
          />

          {isDesktop && (
            <Box
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                bottom: "5%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
                zIndex: 2
              }}
            >
              <Box
                component={motion.div}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.98 }}
              >
                <Button
                  href="/calendario-de-partidos"
                  disableElevation
                  sx={{
                    px: 5,
                    height: 54,
                    borderRadius: "14px",
                    backgroundColor: "primary.main",
                    color: "primary.contrastText",
                    fontWeight: 700,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "primary.main"
                    }
                  }}
                >
                  View Schedule
                </Button>
              </Box>

              <Box
                component={motion.div}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.08 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.98 }}
              >
                <Button
                  href="/galeria"
                  disableElevation
                  sx={{
                    px: 5,
                    height: 54,
                    borderRadius: "14px",
                    backgroundColor: "#fff",
                    color: "primary.main",
                    border: "2px solid",
                    borderColor: "primary.main",
                    fontWeight: 700,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#fff",
                      borderColor: "primary.main"
                    }
                  }}
                >
                  View Gallery
                </Button>
              </Box>
            </Box>
          )}
        </Box>

        {!isDesktop && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              mt: 3,
              justifyContent: "center",
              flexWrap: "wrap"
            }}
          >
            <Box
              component={motion.div}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.98 }}
            >
              <Button
                href="/calendario-de-partidos"
                disableElevation
                sx={{
                  px: 3,
                  height: 44,
                  borderRadius: "14px",
                  backgroundColor: "primary.main",
                  color: "primary.contrastText",
                  fontWeight: 700,
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "primary.main"
                  }
                }}
              >
                View Schedule
              </Button>
            </Box>

            <Box
              component={motion.div}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut", delay: 0.08 }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.98 }}
            >
              <Button
                href="/galeria"
                disableElevation
                sx={{
                  px: 3,
                  height: 44,
                  borderRadius: "14px",
                  backgroundColor: "#fff",
                  color: "primary.main",
                  border: "2px solid",
                  borderColor: "primary.main",
                  fontWeight: 700,
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#fff",
                    borderColor: "primary.main"
                  }
                }}
              >
                View Gallery
              </Button>
            </Box>
          </Box>
        )}
      </Container>
    </Box>
  );
}

export default HeroSection;